/**
 * @title: 视频
 */

import React from 'react';
import PropTypes from 'prop-types';
import useSettings from '../../vm-hooks/useSettings';
import { BillPlayer } from '@vtx/player';
function Video(props) {
    const { theme } = useSettings();
    return (
        <BillPlayer
            height={700}
            width={'100%'}
            isDark={theme === 'dark'}
            params={{ billId: props.billId }}
            history={true}
            live={true}
        />
    );
}

Video.propTypes = {
    billId: PropTypes.string,
};

export default Video;
